import {TabsProps} from "antd";
import React, {useEffect, useRef} from "react";
import GlassStorehouseSub from "./Store/Store";
import ImportExport from "./Import/Import";
import Chart from "./Chart/Chart";
import Catalog from "./Catalog/Catalog";
import {Tabs} from "components/common";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {tabKeys} from "types/enums";
import Detail from "./Detail/Detail";
import ExportTab from "./Export/Export";
import {setButtonsHeader, setSiderKey} from "redux/reducer/common";

const GlassStoreHouse = () => {
  document.title = "Kho kính";
  const activeTab = useAppSelector(state => state.common.activeTab);
  const detailRef = useRef<any>();
  const dispatch = useAppDispatch();
  // useEffect(() => {
  //   localStorage.setItem("khoUserGlassId", "21");
  // });
  const items: TabsProps["items"] = [
    {
      key: tabKeys.GLASSES_STOREHOUSE.STORE_GLASS,
      label: "Kho kính",
      children: <GlassStorehouseSub />,
    },
    {
      key: tabKeys.GLASSES_STOREHOUSE.IMPORT,
      label: "Phiếu nhập",
      children: <ImportExport />,
    },
    {
      key: tabKeys.GLASSES_STOREHOUSE.EXPORT,
      label: "Phiếu xuất",
      children: <ExportTab />,
    },
    {
      key: tabKeys.GLASSES_STOREHOUSE.DETAIL,
      label: "Chi tiết phiếu",
      children: <Detail ref={detailRef} />,
    },
    // {
    //   key: tabKeys.GLASSES_STOREHOUSE.REPORT_TAB_GLASS,
    //   label: "Báo cáo nâng cao",
    //   children: <Chart />,
    // },
    {
      key: tabKeys.GLASSES_STOREHOUSE.CATALOG,
      label: "Cấu hình hệ thống",
      children: <Catalog />,
    },
  ];

  useEffect(() => {
    dispatch(setButtonsHeader([]));
    dispatch(setSiderKey("khoKinh"));
  }, [activeTab]);

  return (
    <div className="glass-storehouse page">
      <div className="main">
        <Tabs activeKey={activeTab} items={items} />
      </div>
    </div>
  );
};

export default GlassStoreHouse;
